import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';

export default function CopyIdElement(props) {
    const { isShow, copyId, messageShareLink, title, setChatPostShowFlagMsgCopyMsgId } = props;

    if (!isShow) return null;

    const onClickCopy = () => {
        navigator.clipboard.writeText(messageShareLink);
        if(!setChatPostShowFlagMsgCopyMsgId) return 
        setChatPostShowFlagMsgCopyMsgId((prev)=> {
            return {
                ...prev,
                [copyId]: true
            }
        });

        setTimeout(() => {
            setChatPostShowFlagMsgCopyMsgId(prev=>{
                return {
                    ...prev,
                    [copyId]: false
                }
            });
        }, 3000);
    };

    return (
        <Tooltip title={title ? title : ""} arrow placement="top-center">
            <IconButton
                className="copy-id-element-content"
                onClick={() => onClickCopy()}
                disabled={false}
            >
                <img src="/assets/image/icon-link-share.svg" alt="" />
            </IconButton>
        </Tooltip>
    );
}
